import React from "react";
import {
  Document,
  Font,
  Page,
  Text,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";
import logo from "../../assets/img/logo-removebg-preview.png";
// Registrar la fuente
Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

// Estilos para el PDF
const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Oswald",
    marginBottom: 20,
  },
  text: {
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 18,
    fontFamily: "Oswald",
    marginBottom: 10,
    color: "#333333",
  },
  contentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  contentKey: {
    fontSize: 14,
    fontFamily: "Oswald",
    color: "#333333",
  },
  contentValue: {
    fontSize: 14,
    fontFamily: "Times-Roman",
    color: "#555555",
  },
  footer: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  wrapper: {
    border: "1px solid #dddddd",
    padding: 10,
    borderRadius: 5,
    marginBottom: 10,
  },
  textWrapper: {
    marginBottom: 20,
  },
  table: {
    display: "table",
    width: "100%",
    marginTop: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#676767",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: "auto",
    width: 100,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#676767",
    backgroundColor: "#f2f2f2",
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#676767",
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 14,
    fontFamily: "Oswald",
  },
  tableCell: {
    margin: 5,
    fontSize: 14,
    fontFamily: "Times-Roman",
  },
});

const formatDateTime = (date) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return new Intl.DateTimeFormat("es-ES", options).format(new Date(date));
};

// Componente principal para generar el documento PDF
function MyDocument({ data }) {
  const currentDate = new Date();
  const formattedDate = formatDateTime(currentDate);

  return (
    <>
      {data ? (
        <Document title={`Historial de Cambio - ${data.producto}`}>
          <Page style={styles.body}>
            {/* Título principal */}
            <Image style={styles.image} src={logo} />
            <Text style={styles.title}>Historial de Cambio</Text>

            {/* Sección de detalles del historial */}
            <View style={styles.wrapper}>
              <Text style={styles.sectionTitle}>Detalles del Historial</Text>
              <View style={styles.contentRow}>
                <Text style={styles.contentKey}>Producto:</Text>
                <Text style={styles.contentValue}>{data.producto}</Text>
              </View>
              <View style={styles.contentRow}>
                <Text style={styles.contentKey}>Tipo de Cambio:</Text>
                <Text style={styles.contentValue}>{data.tipo_cambio}</Text>
              </View>
              <View style={styles.contentRow}>
                <Text style={styles.contentKey}>Planta:</Text>
                <Text style={styles.contentValue}>{data.planta}</Text>
              </View>
              <View style={styles.contentRow}>
                <Text style={styles.contentKey}>Usuario:</Text>
                <Text style={styles.contentValue}>
                  {data.user.first_name} {data.user.last_name}
                </Text>
              </View>
              <View style={styles.contentRow}>
                <Text style={styles.contentKey}>Fecha de Modificación:</Text>
                <Text style={styles.contentValue}>
                  {formatDateTime(data.fecha_modificacion)}
                </Text>
              </View>
            </View>

            {/* Sección de cambios realizados */}
            <View style={styles.wrapper}>
              <Text style={styles.sectionTitle}>Cambios Realizados</Text>
              <Text style={styles.text}>{data.cambios}</Text>
            </View>

            {/* Pie de página */}
            <Text style={styles.footer}>
              Reporte generado el {formattedDate}
            </Text>
          </Page>
        </Document>
      ) : (
        "No se pudieron obtener los datos"
      )}
    </>
  );
}

export default MyDocument;
